import classNames from 'classnames';
import { ConnectOrganizationMessage } from './ConnectOrganizationMessage';
import { LoadingSpinner } from '@ui/LoadingSpinner';
import { MissingPermissionMessage } from './MissingPermissionMessage';
import { SyncOutlined } from '@ant-design/icons';

import { Button, Row, Space } from 'antd';
import { GatewayCard, GatewayContent } from '../../general';
import { ONBOARDING_CONNECT_COPY, ONBOARDING_NO_PERMISSION_COPY } from '@sonar-software/sonar-ts-constants';
import { OnboardingStep, OnboardingSteps } from './OnboardingSteps';
import React, { useState } from 'react';
import { useCurrentCustomer, useCurrentOrganization, useOnboardingProgress, useSalesforceSync } from '@hooks';

export interface ConfirmOrganizationViewProps {
	onRestart: () => void;
}

export const ConfirmOrganizationView: React.FC<ConfirmOrganizationViewProps> = ({ onRestart }) => {
	const customer = useCurrentCustomer(true);
	const { startSync } = useSalesforceSync();
	const { progress } = useOnboardingProgress();
	const selectedOrganization = useCurrentOrganization();
	const [ isProcessing, setIsProcessing ] = useState(false);

	if (!customer || !progress || !selectedOrganization) {
		return <LoadingSpinner spinning />;
	}

	const isMissingSyncPermission = progress?.missingSalesforceSyncPermission;

	return (
		<GatewayContent>
			<GatewayCard
				className={ classNames({ 'onboarding-error-view': isMissingSyncPermission }) }
				pre={ <OnboardingSteps currentStep={ OnboardingStep.Connect } /> }
				title={ isMissingSyncPermission ?
					ONBOARDING_NO_PERMISSION_COPY.CHECK_PERMISSION :
					ONBOARDING_CONNECT_COPY.CONNECT_YOUR_ORGANIZATION }>
				{ !isMissingSyncPermission &&
					<ConnectOrganizationMessage
						customerName={ customer?.name }
						organizationName={ selectedOrganization?.name }
						salesforceUserName={ selectedOrganization?.salesforceUsername } /> }
				{ isMissingSyncPermission && <MissingPermissionMessage /> }
				<br />
				<br />
				<Row justify='center'>
					<Space size={ 4 }>
						<Button
							id='wrong-instance-button'
							loading={ isProcessing }
							onClick={ onRestart }
							size='large'
							type={ isMissingSyncPermission ? 'primary' : 'default' }>
							{ isMissingSyncPermission ?
								ONBOARDING_CONNECT_COPY.START_OVER :
								ONBOARDING_CONNECT_COPY.WRONG_INSTANCE }
						</Button>
						{ !isMissingSyncPermission &&
							<Button
								id='confirm-start-sync-button'
								loading={ isProcessing }
								onClick={ () => {
									setIsProcessing(true);
									startSync();
								} }
								size='large'
								type='primary'>
								<SyncOutlined />
								{ ONBOARDING_CONNECT_COPY.START_SYNC }
							</Button> }
					</Space>
				</Row>
			</GatewayCard>
		</GatewayContent>
	);
};
